<template>
  <g class="mid-indicator">
    <path :d="midIndicatorPath" :style="midIndicatorStyle" /> 
    <path :d="midIndicatorPathOffset" style="fill: none;" stroke="white" :stroke-width="(!isPigtail ? whiteIndicatorOffset : whiteIndicatorPigtailBleeding)"/>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      indicatorHeight: 24,
      indicatorWidth: 12,
      whiteIndicatorOffset: 2,
      whiteIndicatorPigtailBleeding: 1
    }
  },
  props: {
    isPigtail: Boolean,
    svgWidth: Number,
    svgHeight: Number,
    cableColor: String
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),

    // black mid indicator path
    midIndicatorPath: function () {
      return `M${(this.svgWidth / 2)} ${(this.svgHeight / 2 - (this.indicatorHeight / 2))}  
              L${((this.svgWidth / 2) - (this.indicatorWidth / 2))} ${((this.svgHeight / 2) - (this.indicatorHeight / 4))}  
              L${((this.svgWidth / 2) + (this.indicatorWidth / 2))} ${((this.svgHeight / 2) + (this.indicatorHeight / 4))}  
              L${(this.svgWidth / 2)} ${((this.svgHeight / 2) + (this.indicatorHeight / 2))}`
    },
    // white mid indicator path
    midIndicatorPathOffset: function () {
      if (this.isPigtail) 
        return `M${((this.svgWidth / 2) + (this.whiteIndicatorPigtailBleeding - this.whiteIndicatorOffset))} ${(this.svgHeight / 2 - (this.indicatorHeight / 2))} 
                L${((this.svgWidth / 2) - (this.indicatorWidth / 2)) + (this.whiteIndicatorPigtailBleeding - this.whiteIndicatorOffset)} ${((this.svgHeight / 2) - (this.indicatorHeight / 4))} 
                L${((this.svgWidth / 2) + (this.indicatorWidth / 2)) + (this.whiteIndicatorPigtailBleeding - this.whiteIndicatorOffset)} ${((this.svgHeight / 2) + (this.indicatorHeight / 4))} 
                L${((this.svgWidth / 2) + this.whiteIndicatorOffset) + (this.whiteIndicatorPigtailBleeding - this.whiteIndicatorOffset)} ${((this.svgHeight / 2) + (this.indicatorHeight / 2))}`

      return `M${((this.svgWidth / 2) + this.whiteIndicatorOffset)} ${(this.svgHeight / 2 - (this.indicatorHeight / 2))} 
              L${((this.svgWidth / 2) - (this.indicatorWidth / 2) + this.whiteIndicatorOffset)} ${((this.svgHeight / 2) - (this.indicatorHeight / 4))} 
              L${((this.svgWidth / 2) + (this.indicatorWidth / 2) + this.whiteIndicatorOffset)} ${((this.svgHeight / 2) + (this.indicatorHeight / 4))} 
              L${((this.svgWidth / 2) + this.whiteIndicatorOffset)} ${((this.svgHeight / 2) + (this.indicatorHeight / 2))}`
    },
    // mid indicator color based on cable color selection
    midIndicatorStyle: function () {
      let color = this.getCssColor(this.cableColor)
      return `fill: none; stroke-width: 1; stroke: ${color};`
    }
  }
}
</script>